import { render } from "./modal-settings.vue?vue&type=template&id=79ebcbf6"
import script from "./modal-settings.vue?vue&type=script&lang=js"
export * from "./modal-settings.vue?vue&type=script&lang=js"

import "./modal-settings.vue?vue&type=style&index=0&id=79ebcbf6&lang=css"

import exportComponent from "C:\\Users\\domin\\Desktop\\workspace\\hub-web-apps\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__